import { useSearchParams, Navigate } from "react-router-dom";

export default function Join() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  if (ref) {
    try {
      localStorage.setItem("lidlink-ref", ref.trim().toUpperCase());
    } catch {
      /* ignore */
    }
  }
  return <Navigate to="/people#register" replace />;
}
